module.exports = __webpack_public_path__ + "img/icon-puzzle-bonus.39340d1f.svg";